import { Pipe, PipeTransform } from '@angular/core';

/*
  Splits a camel case string by the capital letters, and returns a new string with spaces in between them. For example,
  "CamelCaseString" will become "Camel Case String"
 */
@Pipe({
  name: 'camelCaseSplit',
  standalone: false,
})
export class CamelCasePipe implements PipeTransform {
  transform(camelCase: string | null | undefined): string | null {
    if (!camelCase) {
      return null;
    }
    return camelCase.split(/(?=[A-Z])/).join(' ');
  }
}
